import React, { useEffect, useState } from "react";
import {
  Alert,
  Avatar,
  Badge,
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  Link,
  LinearProgress,
  Paper,
  Rating,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from "@mui/material";
import BakerStatus from "../component/BakerStatus";
import IconText from "../../common/component/IconText";
import { AlternateEmail, Cake, Fingerprint, Instagram, PhoneAndroid, Person, Phone, Room } from "@mui/icons-material";
import bkstApi from "../../common/component/api";
import ReviewAdmin from "../../common/component/review/ReviewAdmin";
import ReviewAdd from "../../common/component/review/ReviewAdd";
import PicUploadMultiple from "../../common/component/PicUploadMultiple";
import ClickToCopy from "../../common/component/ClickToCopy";
import { useParams, Link as RouterLink } from "react-router-dom";
import ProductSearch from "../../product/screen/ProductSearch";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import AdminBakerEditFlavors from "../../baker/component/AdminBakerEditFlavors";
import { BAKER_PIC_FOLDER, bakeStreetSquareLogo } from "../../common/component/constants";
import moment from "moment";
import AdminChatWithBaker from "../../baker/component/AdminChatWithBaker";
import Row from "../../product/component/ProductDetail";
import BakerOrders from "../component/BakerOrders";
import BakerQuotes from "../component/BakerQuotes";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useLocation } from "react-router-dom";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import NotificationIcon from "../../notification/component/NotificationIcon";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router";
import { sortNotifications } from "../../common/component/util";
import { getQueryParam } from "../../common/component/util";
import BakerStaff from "../component/BakerStaff";
import OnlineShop from "../../product/screen/OnlineShop";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { Timeline, TimelineDot, TimelineContent, TimelineConnector, TimelineSeparator } from "@mui/lab";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import CloudinaryUploadWidget from "../../common/component/CloudinaryUploadWidget";
import BakerConfig from "../component/BakerConfig";
import BakeryCustomers from "../component/BakeryCustomers";

export default function BakerDetail(props) {
  let location = useLocation();
  const navigate = useNavigate();

  const { bakerId } = useParams();

  const [baker, setBaker] = useState();
  const [publicData, setPublicData] = useState();
  const [privateData, setPrivateData] = useState();

  const [notifications, setNotifications] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [activity, setActivity] = useState([]);

  const [uploadCount, setUploadCount] = useState(0);

  const [tab, setTab] = useState("");

  useEffect(() => {
    getData();

    let [tab] = [getQueryParam(window.location.search, "tab")];
    if (tab) {
      setTab(Number(tab));
    }
  }, [bakerId, location.key]);

  useEffect(() => {
    if (tab === 5) {
      bkstApi(`/admin/baker/${bakerId}/notification`).then((res) => {
        setNotifications(res.data.notifications.sort(sortNotifications));
      });
    } else if (tab === 9) {
      bkstApi(`/admin/site/${bakerId}/customer`).then((res) => {
        setCustomers(res.data.customers);
      });
    } else if (tab === 10) {
      bkstApi(`/admin/site/${bakerId}/activity`).then((res) => {
        setActivity(res.data.activity);
      });
    }
  }, [tab]);

  const getData = () => {
    bkstApi(`/admin/bakers/${bakerId}`).then((res) => {
      setBaker(res.data.baker);
      setPublicData(res.data.public);
      setPrivateData(res.data.private);
      setReviews(res.data.reviews);
    });
  };

  const generateProducts = (images) => {
    console.log("generateProducts", images.length);
    bkstApi.post(`/admin/bakers/${bakerId}/products`, { images }).then((res) => {
      setUploadCount(images.length);
    });
  };

  const approve = () => {
    bkstApi.put(`/baker/${bakerId}/approve`).then((res) => {
      getData();
    });
  };

  const addNewReview = (review) => {
    setReviews([review, ...reviews]);
  };

  if (!baker || !publicData || !privateData) {
    return <LinearProgress />;
  } else {
    return (
      <Box my={2}>
        <Container maxWidth="xl">
          <Box>
            <Grid container spacing={2} alignItems="center">
              <Grid item sm={6} xs={4}>
                <Tooltip title="View in DB">
                  <IconButton
                    target="_blank"
                    href={`https://console.firebase.google.com/project/bakestreet-f55a0/firestore/data/~2Fbaker~2F${bakerId}`}
                  >
                    <Fingerprint />
                  </IconButton>
                </Tooltip>
                <IconButton
                  target="_blank"
                  href={`https://console.firebase.google.com/u/0/project/bakestreet-f55a0/storage/bakestreet-f55a0.appspot.com/files/~2Fimg~2Fsite~2F${bakerId}`}
                >
                  <CloudUploadOutlinedIcon />
                </IconButton>
              </Grid>
              <Grid item sm={6} xs={8} align="right">
                <AdminChatWithBaker name={baker.name} bakerId={bakerId} />
                <Tooltip title="Report">
                  <IconButton component={RouterLink} to={`/baker/${bakerId}/report`}>
                    <AssessmentOutlinedIcon />
                  </IconButton>
                </Tooltip>
                {baker && baker.status === "new" && (
                  <Tooltip title="Approve Baker">
                    <IconButton onClick={approve}>
                      <PowerSettingsNewIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {/* <Tooltip title="Pricing Model">
                  <IconButton component={RouterLink} to={`/baker/${bakerId}/config/pricing`}>
                    <AttachMoneyOutlinedIcon />
                  </IconButton>
                </Tooltip> */}
                <Tooltip title="Edit Baker">
                  <IconButton component={RouterLink} to={`/baker/${bakerId}/edit`}>
                    <EditOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
          <Paper elevation={0} style={{ backgroundColor: "#EEE" }}>
            <Box p={2}>
              <Grid container spacing={3}>
                <Grid item xs={3} sm={3} align="center">
                  <Badge
                    overlap="circular"
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right"
                    }}
                    style={{ width: "100%", height: "auto" }}
                    badgeContent={
                      <Avatar
                        alt=""
                        src={privateData.photo}
                        style={{ border: "2px solid #fff", width: "50px", height: "50px" }}
                      />
                    }
                  >
                    <img
                      alt={baker.bizName}
                      src={privateData.logo}
                      style={{ width: "100%", height: "auto", border: "1px solid #FFF" }}
                    />
                  </Badge>
                </Grid>
                <Grid item xs={9} sm={9}>
                  <Box>
                    <Typography variant="h5">
                      {baker.bizName}&nbsp;
                      <BakerStatus status={baker.status} />
                    </Typography>
                    <Box mb={1}>
                      <Grid container spacing={1} alignItems="center">
                        <Grid item>
                          <Rating size="small" name="rating" precision={0.25} value={Number(baker.rating)} readOnly />
                        </Grid>
                        <Grid item>
                          <Typography variant="caption" color="textSecondary">
                            {baker.rating}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                    <Box style={{ color: "#777" }} mb={1}>
                      <IconText icon={Person} variant="body2" text={`${privateData.firstName} ${privateData.lastName}`} />
                      <IconText
                        icon={Room}
                        variant="body2"
                        text={`${privateData.street}, ${baker.location.city}, ${baker.location.state} ${baker.location.zip}`}
                      />
                    </Box>
                    <Box>
                      {publicData.ig && (
                        <IconButton size="small" target="_blank" href={publicData.ig}>
                          <Instagram />
                        </IconButton>
                      )}
                      <ClickToCopy icon={AlternateEmail} text={privateData.email} />
                      <ClickToCopy icon={Phone} text={privateData.phone} />
                      <ClickToCopy icon={PhoneAndroid} text={privateData.mobile} />
                    </Box>
                    {/* <Box my={1}>
                      {privateData.tags &&
                        privateData.tags.map((t, i) => {
                          return <Chip key={i} size="small" label={t} />;
                        })}
                      </Box> */}
                  </Box>
                </Grid>
              </Grid>
              {/* <Box my={1}>
                <TextWithReadMore data={publicData.bio} limit="140" />
                    </Box> */}
            </Box>
          </Paper>
          <Box sx={{ border: "1px solid #EEE" }}>
            <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
              <Tab label="Config" />
              <Tab label="Quotes" />
              <Tab label="Orders" />
              <Tab label="Shop" />
              <Tab label="Gallery" />
              <Tab label="Notifications" />
              <Tab label="Profile" />
              <Tab label="Reviews" />
              <Tab label="Staff" />
              <Tab label="Customers" />
              <Tab label="Activity" />
            </Tabs>
          </Box>
          <Box>
            {tab === 0 && <BakerConfig bakerId={bakerId} sizeChart={privateData.config.sizeChart} />}
            {tab === 1 && (
              <Grid container>
                <Grid item sm={12}>
                  <BakerQuotes bakerId={bakerId} />
                </Grid>
              </Grid>
            )}
            {tab === 2 && (
              <Grid container>
                <Grid item sm={12}>
                  <BakerOrders bakerId={bakerId} />
                </Grid>
              </Grid>
            )}
            {tab === 3 && <OnlineShop siteId={bakerId} />}
            {tab === 4 && (
              <Box my={4}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Typography variant="h4">Photo Gallery</Typography>
                  {+uploadCount > 0 && (
                    <Box my={2} sx={{ backgroundColor: "" }}>
                      <Alert
                        severity="info"
                        action={
                          <Button size="small" onClick={() => navigate(`/baker/${bakerId}?tab=3`)}>
                            View Photos
                          </Button>
                        }
                      >
                        {uploadCount} new photo(s) uploaded
                      </Alert>
                    </Box>
                  )}
                  <CloudinaryUploadWidget folder={`s/${bakerId}/gallery`} onComplete={(images) => generateProducts(images)}>
                    <Button variant="contained" color="primary">
                      Upload
                    </Button>
                  </CloudinaryUploadWidget>
                </Box>
                <ProductSearch bakerId={bakerId} />
              </Box>
            )}
            {tab === 5 && (
              <Box>
                <Box mt={2} mb={4} textAlign="center">
                  <Typography variant="h2">{notifications.filter((item) => item.status === "open").length}</Typography>
                  <Typography variant="overline" color="textSecondary">
                    UNREAD NOTIFICATIONS
                  </Typography>
                </Box>
                {notifications.map((item, idx) => (
                  <Paper key={idx} elevation={0}>
                    <Box p={2} my={2}>
                      <Box sx={{ display: "flex", gap: "10px", width: "100%", opacity: item.status === "open" ? 1 : 0.5 }}>
                        <Box pt={0.5}>
                          <Badge badgeContent={item.count} color="secondary" overlap="circular">
                            <NotificationIcon type={item.heading} priority={item.priority} />
                          </Badge>
                        </Box>
                        <Box sx={{ flexGrow: "1" }}>
                          <Typography variant="body2">{item.heading}</Typography>
                          <Typography
                            title={item.text}
                            variant="body2"
                            color="textSecondary"
                            style={{ whiteSpace: "normal", maxHeight: "1.2rem", overflow: "hidden", textOverflow: "ellipsis" }}
                          >
                            {item.text}
                          </Typography>
                          <Box mt={0.5} style={{ fontSize: ".8rem", color: "#888" }}>
                            <Grid container alignItems="center">
                              <Grid item>
                                <AccessTimeOutlinedIcon style={{ fontSize: "14px", marginRight: "5px" }} />
                              </Grid>
                              <Grid item>{`${moment(item.ts._seconds * 1000).fromNow()}`}</Grid>
                            </Grid>
                          </Box>
                        </Box>
                        <Box>
                          <IconButton onClick={() => navigate(item.link.replace("/my", ""))}>
                            <VisibilityOutlinedIcon />
                          </IconButton>
                        </Box>
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Box>
            )}
            {tab === 6 && (
              <Box my={4}>
                <Grid container spacing={4}>
                  <Grid item sm={12} xs={12}>
                    <Typography variant="overline" color="textSecondary">
                      Links
                    </Typography>
                    <Paper>
                      <Box px={4} py={2} sx={{ display: "flex", gap: "10px", fontSize: "12px" }}>
                        {baker && baker.handle && (
                          <Link component="a" href={`${process.env.REACT_APP_PUBLIC_VIEW_BASE_URL}/shop/${baker.handle}`} target="_blank">
                            BakeStreet Shop
                          </Link>
                        )}
                        <Link
                          component="a"
                          target="_blank"
                          href={`https://console.firebase.google.com/u/0/project/bakestreet-f55a0/storage/bakestreet-f55a0.appspot.com/files/~2Fimages~2Fbakers~2F${baker.id}~2Fportfolio`}
                        >
                          Marketplace Photos
                        </Link>
                      </Box>
                    </Paper>
                  </Grid>
                  <Grid item sm={12} xs={12}>
                    <AdminBakerEditFlavors data={publicData} bakerId={bakerId} />
                  </Grid>
                </Grid>
              </Box>
            )}
            {tab === 7 && (
              <Box>
                <ReviewAdd baker={baker} onDone={addNewReview} />
                <Grid container spacing={2}>
                  {reviews.map((el) => {
                    return (
                      <Grid item sm={6} xs={12} key={el.id}>
                        <ReviewAdmin key={el.id} data={el} baker={baker} />
                      </Grid>
                    );
                  })}
                </Grid>
              </Box>
            )}
            {tab === 8 && (
              <Box p={2}>
                <BakerStaff acctId={bakerId} />
              </Box>
            )}
            {tab === 9 && <BakeryCustomers customers={customers} onChange={(o) => setCustomers([o, ...customers])} />}
            {tab === 10 && (
              <Box p={2} mt={5}>
                <Box>
                  <Timeline
                    sx={{
                      [`& .${timelineItemClasses.root}:before`]: {
                        flex: 0,
                        padding: 0
                      }
                    }}
                  >
                    {activity
                      .sort((o1, o2) => (o1.ts > o2.ts ? -1 : 1))
                      .map((o) => {
                        return (
                          <TimelineItem key={o.ts}>
                            <TimelineSeparator>
                              <Avatar src={`https://storage.googleapis.com/bakestreet-f55a0.appspot.com/img/u/${o.uid}.webp`} />
                              <TimelineConnector />
                            </TimelineSeparator>
                            <TimelineContent ml={1} mb={4} sx={{ backgroundColor: "#F7F7F7" }}>
                              <Box>
                                <Typography variant="body1">{o.type}</Typography>
                                <Typography variant="caption" color="textSecondary">
                                  {JSON.stringify(o)}
                                </Typography>
                                <Box mt={1}>
                                  <Typography variant="caption" color="textSecondary" display="block">
                                    {`${moment(o.ts).format("ddd, MMM DD, YYYY h:mm a")} (${moment(o.ts).fromNow()})`}
                                  </Typography>
                                </Box>
                              </Box>
                            </TimelineContent>
                          </TimelineItem>
                        );
                      })}
                  </Timeline>
                </Box>
                ;
              </Box>
            )}
          </Box>
        </Container>
      </Box>
    );
  }
}
